export const FETCH_STUDENT_COURSE = 'FETCH_STUDENT_COURSE';
export const START_STUDENT_COURSE = 'START_STUDENT_COURSE';
export const END_STUDENT_COURSE = 'END_STUDENT_COURSE';
export const FETCH_STUDENT_COURSES = 'FETCH_STUDENT_COURSES';
export const FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT = 'FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT';

